import type { ReportBenchmark } from './types';

export interface RankingCandidate {
  jurisdictionId: string;
  value: number;
}

/** Standard competition ranking: 1,2,2,4 */
export function competitionRank(values: RankingCandidate[], targetId: string): number | null {
  const sorted = [...values].sort((a, b) => {
    if (b.value !== a.value) return b.value - a.value;
    return a.jurisdictionId.localeCompare(b.jurisdictionId);
  });
  let rank = 0;
  let prev: number | null = null;
  const rankMap = new Map<string, number>();
  for (let i = 0; i < sorted.length; i++) {
    if (prev === null || sorted[i].value !== prev) rank = i + 1;
    rankMap.set(sorted[i].jurisdictionId, rank);
    prev = sorted[i].value;
  }
  return rankMap.get(targetId) ?? null;
}

export function buildRankingBenchmark(
  comparisonType: string,
  metricLabel: string,
  scopeLabel: string,
  targetId: string,
  candidates: RankingCandidate[],
  universeSize: number,
  commonYear: number
): ReportBenchmark {
  const qualified = candidates.filter((c) => Number.isFinite(c.value));
  const qualifiedCount = qualified.length;
  const excludedCount = universeSize - qualifiedCount;
  return {
    comparisonType,
    metricLabel,
    scopeLabel,
    rank: competitionRank(qualified, targetId),
    qualifiedCount,
    universeSize,
    excludedCount,
    tieMethod: 'competition_rank_equal_values',
    publicationStatus: 'provisional',
    commonYear,
    eligibility: {
      eligible: qualified.some((c) => c.jurisdictionId === targetId),
      exclusionReasons: [],
      sectorCoverageUsed: [],
      rankingMetric: comparisonType,
      inventoryYear: commonYear,
      universeVersionId: 'CA_MUNICIPAL_FROZEN_2023_INVENTORY_v1',
    },
  };
}
